import React from 'react';
import { compose, pipe, filter, pluck } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { connect } from 'react-redux';
import moment from 'moment';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import Engine from '@synergycms_core/components/functional/Engine';
import actions from '../../../store/actions';
import { fromJS, List } from 'immutable';
import { contextualizeAppConfig } from "@synergycms_core/store/app/utils";

import AvailDatepicker from '../AvailDatepicker/AvailDatepicker.jsx';
class availEngine extends React.Component {
  static displayName = 'AvailEngine';

  executeSearch = state => {
    this.props.config.executeSearch(state);
  };

  showAvailDatePicker = show => {
    this.props.config.showEngine(show);
  };


  render() {
    const { webType, data: engineSygyData, hideCloseButton } = this.props.config;
    return (
      <Engine
        hideBoards={true}
        DatepickerComponent={AvailDatepicker}
        executeSearch={this.executeSearch}
        getEngine={this.props.config.getEngine}
        params={this.props.config.params}
        engineModules={engineSygyData.engine_modules}
        inAvail={true}
        hideCloseButton={hideCloseButton}
        group={engineSygyData.group}
        lang={engineSygyData.lang}
        childsInfo={engineSygyData.occups_free}
        dropDownListType={engineSygyData.drop_down_list_type}
        hotelsInfo={window.frontLoader?.hotels_info || window.hotels_info}
        webType={webType}
        showTexts={engineSygyData.show_texts}
        showModalView={true}
        limits={engineSygyData.limits}
        outerWeb={false}
        showEngine={this.showAvailDatePicker}
        engineSygyData={engineSygyData}
        links={engineSygyData.links}
        dateFormat={engineSygyData.show_date_format}
        extraInfo={
          {
            ...(engineSygyData.hotels_catalog && {hotels_catalog: engineSygyData.hotels_catalog}),
            ...(engineSygyData.enable_promotion_code && {enable_promotion_code: engineSygyData.enable_promotion_code}),
          }
        }
        backDrop={engineSygyData.back_drop}
      />
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showEngine: show => {
      dispatch(actions.customer.header.show('engine', show));
    },
    executeSearch: state => {
      const selected = state.selectedSearch;
      const country_id = !selected.country_id && !selected.code ? selected.id : null;
      const city_id = selected.country_id ? selected.id : null;
      const hotelsInfo = window.frontLoader?.hotels_info?.hotels || window.hotels_info?.hotels
      let hotels = null;
      const hotelId = selected.id && selected.code ? selected.id : null;
      if (city_id) {
        hotels = pipe(
          filter(hotel => hotel.city_id === city_id),
          pluck('id')
        )(hotelsInfo);
      } else if (country_id) {
        hotels = pipe(
          filter(hotel => hotel.country_id === country_id),
          pluck('id')
        )(hotelsInfo );
      }

      dispatch(
        actions.customer.params.updateParams(
          fromJS({
            date: state.start,
            stay_length: moment(state.end).diff(moment(state.start), 'd', true),
            occups: { ...state.occups },
            city_id: (selected.country_id && !selected.code ) ? selected.id : (selected.city_id) ? selected.city_id : null,
            country_id: !selected.country_id && !selected.code ? selected.id : null,
            promotion_code: state.promoCode,
            hotelId,
            hotels: !hotelId && hotels,
            selection_avail: null
          })
        )
      );
      dispatch(actions.customer.header.show('engine', false));
      dispatch(actions.router.update(true));
    },
    getEngine: (hotelId, hotelCode) => {
      dispatch(actions.hotels.getAsync(List([hotelId])));
    },
  };
};

const mapStateToProps = store => {
  const params = store.getIn(['customer', 'params', 'url_params']);
  const webType = store.getIn(['customer', 'web_type'], false);

  let hotelId = store.getIn(["customer", "current_hotel"])
  const selectedHotelId = store.getIn(['customer', 'selected_hotel']);
  const engineConfigs = contextualizeAppConfig(store, selectedHotelId || hotelId, "engine_config");
  const group = store.get('group', false);

  const maxRooms = engineConfigs.get('max_rooms') || engineConfigs.getIn(['limits', 'rooms', 'max'], 10)
  const maxAdults = engineConfigs.get('max_adults') !== undefined ? engineConfigs.get('max_adults') : engineConfigs.getIn(['limits', 'adults', 'max'], 8)
  const defaultAdults = engineConfigs.get('default_adults') !== undefined ? engineConfigs.get('default_adults') : engineConfigs.getIn(['limits', 'adults', 'default'], 2)
  const maxChilds = engineConfigs.get('max_childs') !== undefined ? engineConfigs.get('max_childs') : engineConfigs.getIn(['limits', 'childs', 'max'], 0)
  const defaultChilds = engineConfigs.get('default_childs') !== undefined ? engineConfigs.get('default_childs') : engineConfigs.getIn(['limits', 'childs', 'default'], 0)

  const lang = store.getIn(['customer', 'lang_info', 'code']) || engineConfigs.get('lang');

  let childsInfo = store.getIn(['hotels', selectedHotelId || hotelId, 'occups_free'],null);
  const enableAge = (!!childsInfo && Number.isFinite(childsInfo.getIn(["baby", "start"])) && Number.isFinite(childsInfo.getIn(["child","end"])));
  const defaultAge = engineConfigs.get('default_babies_age', null) ? engineConfigs.get('default_babies_age') : engineConfigs.getIn(['limits', 'childs', 'defaultAge'], null);
  let defaultChildAge = null;
  if(enableAge && Number.isFinite(defaultAge)){
    defaultChildAge = defaultAge;
  } else if(enableAge) {
    defaultChildAge = childsInfo.getIn(["child","end"]) || 11;
  }

  let data = {
    hotel_id: engineConfigs.get('hotel_id'),
    limits : {
      'rooms':{
        'max': maxRooms,
        'min': 1
      },
      'adults':{
        'max': maxAdults,
        'min': 1,
        'default': defaultAdults,
      },
      'childs':{
        'max': maxChilds,
        'min': 0,
        'default': defaultChilds,
        'defaultAge':defaultChildAge
      }
    },
    occups: {
      "0": {
        "adults": defaultAdults,
        "childs": defaultChilds
      }
    },
    show_date_format: engineConfigs.get('show_date_format', 'minified'),
    outer_web : engineConfigs.get('outer_web'),
    show_texts : engineConfigs.get('show_texts'),
    enable_wi_url : engineConfigs.get('enable_wi_url'),
    show_modal_view : engineConfigs.get('show_modal_view', false),
    focus_on_modal_view : engineConfigs.get('focus_on_modal_view', true),
    engine_visible : engineConfigs.get('engine_visible', true),
    engine_modules : engineConfigs.get('engine_modules', false),
    drop_down_list_type : engineConfigs.get('drop_down_list_type') ? 'nested_destinations' : null,
    theme_values : engineConfigs.get('theme_values'),
    ignore_synergy_config: engineConfigs.get('ignore_synergy_config', true),
    enable_promotion_code: engineConfigs.get('enable_promotion_code', true),
    hotels_catalog: webType === "PORTAL" ? engineConfigs.getIn(['hotels_catalog', lang]) : null,
    occups_free: enableAge && childsInfo?.toJS(),
    url: engineConfigs.get('avail_url') || engineConfigs.getIn(['url', lang]) || engineConfigs.get('url'),
    lang,
    web_type : webType,
    group,
    back_drop : engineConfigs.get('back_drop'),
    city_province_mode: engineConfigs.get('city_province_mode', 'city'),
  }
  return {
    params: params ? params.toJS() : undefined,
    webType: webType,
    data
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager(['params', 'executeSearch', 'getEngine', 'webType', 'showEngine', 'data', 'hideCloseButton'])
)(availEngine);
